import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import UiConfirmDialog from 'ui-components/ui-confirm-dialog/UiConfirmDialog';
import UiButton from 'ui-components/ui-button/UiButton';
import UiIcon from 'ui-components/ui-icon/UiIcon';
import { UiErrors } from 'components/error/Error';

export function UiTableConfirm(props) {
  const { t } = useTranslation();
  const {
    isOpen,
    className,
    children,
    confirmTitle = t('common:removeIt'),
    cancelTitle = t('common:cancel'),
    onConfirm,
    onCancel,
    message,
    loading,
    error,
    dataTestId,
  } = props;
  const [open, setOpen] = React.useState(false);
  const [_error, _setError] = React.useState(error);

  useEffect(() => {
    _setError(error);
  }, []);

  const openConfirm = () => {
    setOpen(true);
    _setError(null);
  };

  const closeConfirm = () => {
    setOpen(false);
  };

  const handelConfirm = () => {
    if (onConfirm) {
      onConfirm(closeConfirm);
      return;
    }
    closeConfirm();
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel(closeConfirm);
      return;
    }
    closeConfirm();
  };

  return (
    <>
      {children && (
        <div className={className} onClick={openConfirm}>
          {children}
        </div>
      )}
      <UiConfirmDialog
        open={isOpen !== undefined ? isOpen : open}
        actions={
          <>
            <UiButton
              variant='outlined'
              color='secondary'
              startIcon={<UiIcon icon='ri-delete-bin-7-line' color='#F16063' />}
              onClick={handelConfirm}
              disabled={loading}
              loading={loading}
              data-testid={`${dataTestId}-ok`}
            >
              {confirmTitle}
            </UiButton>
            <UiButton
              variant='text'
              autoFocus
              onClick={handleCancel}
              color='primary'
              disabled={loading}
              data-testid={`${dataTestId}-cancel`}
            >
              {cancelTitle}
            </UiButton>
          </>
        }
      >
        {message}
        {_error && <UiErrors errors={_error} />}
      </UiConfirmDialog>
    </>
  );
}

UiTableConfirm.propTypes = {
  isOpen: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  confirmTitle: PropTypes.string,
  cancelTitle: PropTypes.string,
  onConfirm: PropTypes.any,
  onCancel: PropTypes.any,
  message: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.any,
  dataTestId: PropTypes.string,
};

export default UiTableConfirm;
